<div class="navbar-background navbar-container"
[ngClass]="{ 'light-mode': lightMode }">
  <div class="left-container" [ngClass]="{ 'light-mode': lightMode }">
    <div slot="start" class="nav-logo">
      <img class="pointer" (click)="changeRoute('/Home')" width="84px" [src]="path + 'TopNavLogo.png'" />
    </div>
    <div class="divider"></div> 
    <div class="crumbs mauto" [ngClass]="{ 'light-mode': lightMode }">
      <app-bread-crumb #parent>
        <div class="crumb-container">
          <span class="breadcrumb" [ngClass]="{ 'light-mode': lightMode }">
            <a mat-button href="javascript:;" (click)="changeRoute('/Home')">
              <mat-icon>home</mat-icon>
            </a>
          </span>
          @for (route of parent.breadcrumbs; track route) {
            @if (route.displayName != 'Home') {
              <span class="breadcrumb" [ngClass]="{ 'light-mode': lightMode }">
                @if (!route.terminal) {
                <a mat-button href="javascript:;" (click)="changeRoute(route.url)">{{ route.displayName }}</a>
                } @if (route.terminal) {
                  @if (!route.hasParent) {
                    <a mat-button>{{ route.displayName }}</a>
                  } @else {
                    <a mat-button class="terminal-text">{{ route.displayName }}</a>
                  }
                }
              </span>
            }
          }
        </div>
      </app-bread-crumb>
      
    </div>
  </div>
  <div slot="primary" class="top-nav-settings">
    @if (groupName != null) {
      <div class="current-session" [ngClass]="{ 'light-mode': lightMode }">
        <p>SESSION:</p>
        <button 
          class="session-button" 
          [ngClass]="{ 'active':changeSessionOpen, 'light-mode': lightMode}"
          mat-button 
          (click)="openChangeSessionModal($event)">
          <div class="group-name" [ngClass]="{ 'light-mode': lightMode }">
            <label class="group-label">{{ groupName }}</label>
            <mat-icon class="expand-icon">
              {{ changeSessionOpen ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </div>
        </button>
      </div>
      }
    <!-- <div *ngIf="layoutService.screenSize > ScreenSize.TABLET && hasReporting">
        <button
		mat-button
          fill="clear"
          (click)="changeRoute('Reports')">
          <mat-icon
            name="folder-outline"
            [ngClass]="'active'">
          </mat-icon>
        </button>
        <label>Reports</label>
      </div> -->

    <!-- @if (layoutService.screenSize > ScreenSize.TABLET) {
    <div> -->
      <!-- [routerLink]="routerLink" -->
      <!-- <button mat-button fill="clear" (click)="openGoToModal($event)">
        <mat-icon class="icon" [ngClass]="'active'">
          <img src="assets/icon/compass-outline.svg" />
        </mat-icon>
      </button>
      <label class="label" [ngClass]="'active'">Go To</label>
    </div>
    } -->

    <!-- <button mat-button *ngIf="layoutService.screenSize > ScreenSize.TABLET" (click)="openGoToModal($event)">
        <mat-icon [svgIcon]="'assets/icon/compass-outline.svg'"></mat-icon>
      </button> -->
    <!-- <app-navbar-button
				*ngIf="layoutService.screenSize > ScreenSize.TABLET"
				[name]="'settings-outline'"
				(openMenu)="openSettingsModal($event)"
				[label]="'Settings'"></app-navbar-button> -->

    @if (layoutService.screenSize > ScreenSize.TABLET) {
    <div class="nav-buttons" [ngClass]="{ 'light-mode': lightMode }">
      <button 
        class="nav-button " 
        [ngClass]="{ 'active':settingsOpen,'light-mode': lightMode }"
        mat-button fill="clear" 
        (click)="openSettingsModal($event)">
        <mat-icon 
          class="icon" 
          [ngClass]="{ 'active':settingsOpen, 'light-mode': lightMode }">
            settings
        </mat-icon>
      </button>
      <button 
        class="nav-button" 
        [ngClass]="{ 'active':accountOpen, 'light-mode': lightMode }"
        mat-button 
        fill="clear" 
        (click)="openAccountModal($event)">
        <mat-icon 
          class="icon" 
          [ngClass]="{ 'active': accountOpen, 'light-mode': lightMode }">
            account_circle
        </mat-icon>
      </button>
    </div>
    } @if (layoutService.screenSize <= ScreenSize.TABLET) {
    <button mat-button class="settings" (click)="changeRoute('/Home/Navigate')" color="primary" fill="clear">
      <mat-icon><img src="assets/icon/compass-outline.svg" /></mat-icon>
    </button>
    } @if (layoutService.screenSize <= ScreenSize.TABLET) {
    <button mat-button class="settings" (click)="openSettingsModal($event)" color="primary" fill="clear">
      <mat-icon>settings</mat-icon>
    </button>
    }
  </div>
  <!-- <div class="crumbinfo-div">
    <breadcrumb #parent>
      <span class="breadcrumb" *ngFor="let route of parent.breadcrumbs">
          <a mat-button *ngIf="!route.terminal" href="" [routerLink]="[route.url]">{{ route.displayName }}</a>
          <a mat-button *ngIf="route.terminal">{{ route.displayName }}</a>
      </span>
    </breadcrumb>
  </div> -->
</div>
<ng-container #stickyHeader *ngTemplateOutlet="layoutService.stickyHeaderTemplates[navigationService.GetCurrentRoute()]"> </ng-container>
